// Saufdings gRPC backend URL, used by the Saufdings frontend's gRPC clients.
//
// Resolution order is runtime env.js value -> CRA build-time override -> production URL.
// Empty values fall through so a misconfigured deployment cannot issue requests to an empty URL.
import { resolveGrpcBackendUrl, runtimeValue } from '@dowty/core';

export const SSO_ENABLED = process.env.REACT_APP_SSO_ENABLED !== 'false';
export const GRPC_CLIENT_OPTIONS = SSO_ENABLED ? { withCredentials: true } : null;
export const SSO_ISSUER_ORIGIN = runtimeValue('SSO_ISSUER_ORIGIN' as Parameters<typeof runtimeValue>[0])
  || process.env.REACT_APP_SSO_ISSUER_ORIGIN
  || 'https://sso.dowtex.com';

const GRPC_BACKEND_URL = resolveGrpcBackendUrl(
  runtimeValue('GRPC_BACKEND_URL'),
  process.env.REACT_APP_SAUFDINGS_GRPC_BACKEND_URL,
  'https://saufdingsapitoo.dowtex.com',
);

export default GRPC_BACKEND_URL;
